import BaseActionAbstract from 'cio/app-models/action-abstracts/base';
import EmObject, { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import colorLabels from 'cio/utils/color-labels';
import integerToString from 'cio/utils/integer-to-string';
import { task } from 'ember-concurrency';

const SplitAllocation = EmObject.extend({
  allocationString: integerToString('allocation'),
});

const EDITABLE_PROPERTIES = [
  'sendToPlatform',
  'sendToUnsubscribed',
  'useMessageLimits',
  'overrideMessageLimitsRetry',
  'messageLimitsRetryWindowSecs',
  'preconditions',
  'subscriptionTopicId',
];
const DIRTY_DEPENDENCIES = `action.{${EDITABLE_PROPERTIES.join(',')}}`;

export default BaseActionAbstract.extend({
  type: 'split',

  action: null,
  actionType: null,

  _editableProperties: EDITABLE_PROPERTIES,
  _dirtyDependencies: DIRTY_DEPENDENCIES,

  splitAllocations: null,
  preconditions: null,
  sendToPlatform: null,
  sendToUnsubscribed: null,
  useMessageLimits: null,
  overrideMessageLimitsRetry: null,
  messageLimitsRetryWindowSecs: 0,
  subscriptionTopicId: null,

  prepareForEdit() {
    this._super(...arguments);

    this.set(
      'splitAllocations',
      this.action.allocations.map(function (allocation, index) {
        return SplitAllocation.create({
          allocation,
          badge: colorLabels[index],
        });
      }),
    );
  },

  prepareForSave() {
    let action = this._super(...arguments);
    let allocations = this.splitAllocations.mapBy('allocation');

    action.set('allocations', allocations);

    return action;
  },

  splitAllocationsChanged: computed('splitAllocations.@each.allocation', 'action.allocations.[]', function () {
    let { allocations } = this.action;
    let editedAllocations = this.splitAllocations.mapBy('allocation');
    return allocations.some((a, i) => a !== editedAllocations[i]);
  }),

  _isDirty: readOnly('splitAllocationsChanged'),

  // eslint-disable-next-line require-yield
  saveTask: task(function* () {
    // Need to get this before we call prepareForSave, because after that call
    // the allocations will be copied over to the action, and the computed will
    // always return false
    let allocationsChanged = this.splitAllocationsChanged;
    let action = this.prepareForSave();
    let promise = this.action.isSplitInactive && allocationsChanged ? action.startTest() : action.save();

    try {
      let response = yield promise;
      this.prepareForEdit();
      return response;
    } catch (e) {
      action.rollbackAttributes();
      throw e;
    }
  }).drop(),
});
